mutation UpdateContractPaymentNote(
  $id: ID!
  $input: UpdateContractPaymentNoteInput!
) {
  updateContractPaymentNote(id: $id, input: $input) {
    id
    note
  }
}
